// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verfy-wrap {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: url('mesh-gradient.d2e368c6b9d92bb7.png') center center;
  background-size: cover;
  flex-direction: column;
}
.verfy-wrap .verfy-screen-logo {
  margin-top: 60px;
}
.verfy-wrap .verfy-box {
  background: #ffffff;
  border-radius: 20px;
  padding: 40px 94px;
  text-align: center;
  width: 794px;
  margin-top: 60px;
  max-width: 90%;
}
.verfy-wrap .verfy-box h2 {
  font-weight: 600;
  font-size: 32px;
  line-height: 30px;
  color: #000;
  margin-bottom: 16px;
}
.verfy-wrap .verfy-box p {
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  color: #000000;
}
.verfy-wrap .verfy-box .password-wrapper {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 40px;
  padding: 0 20px;
  height: 54px;
  position: relative;
  width: 100%;
}
@media (max-width: 768px) {
  .verfy-wrap .verfy-box {
    padding: 40px 20px;
  }
  .verfy-wrap .verfy-box p {
    font-size: 16px;
    padding: 0 25px;
  }
}

.verify-agency-logo {
  max-width: 450px;
}

.powered-wrapper {
  margin-top: 60px;
  display: flex;
  gap: 4px;
  flex-direction: column;
}
.powered-wrapper span {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.25px;
  color: #1f2937;
}
.powered-wrapper .image-wrapper {
  width: 168px;
}
.powered-wrapper .image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

::-webkit-inner-spin-button {
  display: none;
}

.table-search-wrapper {
  width: 452px;
  height: 46px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  margin-right: 24px;
  overflow: hidden;
}
.table-search-wrapper .table-search-field {
  border: none;
  padding: 0;
  flex: 1 1 auto;
}
.table-search-wrapper .p-inputgroup-addon {
  background: #fff;
  border: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/report-verification/report-verification.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mEAAA;EACA,sBAAA;EACA,sBAAA;AACF;AAAE;EACE,gBAAA;AAEJ;AAAE;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAEJ;AADI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAGN;AADI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAGN;AADI;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAGN;AADI;EAnCF;IAoCI,kBAAA;EAIJ;EAHI;IACE,eAAA;IACA,eAAA;EAKN;AACF;;AADA;EACE,gBAAA;AAIF;;AAFA;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;AAKF;AAJE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAMJ;AAJE;EACE,YAAA;AAMJ;AALI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAON;;AAHA;EACE,aAAA;AAMF;;AAHA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAMF;AALE;EACE,YAAA;EACA,UAAA;EACA,cAAA;AAOJ;AALE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;AAOJ","sourcesContent":[".verfy-wrap {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  background: url(../../assets/images/mesh-gradient.png) center center;\n  background-size: cover;\n  flex-direction: column;\n  .verfy-screen-logo {\n    margin-top: 60px;\n  }\n  .verfy-box {\n    background: #ffffff;\n    border-radius: 20px;\n    padding: 40px 94px;\n    text-align: center;\n    width: 794px;\n    margin-top: 60px;\n    max-width: 90%;\n    h2 {\n      font-weight: 600;\n      font-size: 32px;\n      line-height: 30px;\n      color: #000;\n      margin-bottom: 16px;\n    }\n    p {\n      font-weight: 400;\n      font-size: 24px;\n      line-height: 30px;\n      text-align: center;\n      color: #000000;\n    }\n    .password-wrapper {\n      border: 1px solid #d1d5db;\n      border-radius: 6px;\n      background: #fff;\n      display: flex;\n      align-items: center;\n      gap: 15px;\n      margin-top: 40px;\n      padding: 0 20px;\n      height: 54px;\n      position: relative;\n      width: 100%;\n    }\n    @media (max-width: 768px) {\n      padding: 40px 20px;\n      p {\n        font-size: 16px;\n        padding: 0 25px;\n      }\n    }\n  }\n}\n.verify-agency-logo {\n  max-width: 450px;\n}\n.powered-wrapper {\n  margin-top: 60px;\n  display: flex;\n  gap: 4px;\n  flex-direction: column;\n  span {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n    letter-spacing: -0.25px;\n    color: #1f2937;\n  }\n  .image-wrapper {\n    width: 168px;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n  }\n}\n::-webkit-inner-spin-button {\n  display: none;\n}\n\n.table-search-wrapper {\n  width: 452px;\n  height: 46px;\n  background: #ffffff;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  margin-right: 24px;\n  overflow: hidden;\n  .table-search-field {\n    border: none;\n    padding: 0;\n    flex: 1 1 auto;\n  }\n  .p-inputgroup-addon {\n    background: #fff;\n    border: none;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
